import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import {
  FabricStyleSearchCriteria,
  PageListBean,
  PreProductionSearchCriteria,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestPreProductionListRequest,
  RestReadRequest,
  RestVendorListRequest,
  VendorSearchCriteria,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import {
  DatePickerComponent,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyString } from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { PreProductionService } from "../services/PreProductionService.js";
import { VendorService } from "../services/VendorService.js";
export class PreProductionLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name, vendorCode, status) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    this.vendorCode = vendorCode;
    this.status = status;
    let resetCriteria = new PreProductionSearchCriteria();
    resetCriteria.companyCode = companyCode;
    resetCriteria.vendorCode = vendorCode;
    resetCriteria.status = status;
    this.resetCriteria = resetCriteria;
    let newCriteria = new PreProductionSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let preProductionLookupCriteria = new PreProductionSearchCriteria();
    preProductionLookupCriteria.companyCode = this.companyCode;
    preProductionLookupCriteria.vendorCode = this.vendorCode;
    preProductionLookupCriteria.status = this.status;
    let lookupCriteriaView = PreProductionLookupCriteraHandler(
      companyCode,
      preProductionLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      value
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        value
      );
    };
    this.setDetails(
      lookupDataCallback,
      preProductionLookupCriteria,
      lookupCriteriaView
    );
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true);
    this.addColumnDefinition("Status", "status", 0, false);
    this.addColumnDefinition("Vendor", "vendorCode", 0, false);
    this.addColumnDefinition("VendorName", "vendorName", 0, false);
    this.addColumnDefinition("dev#", "designerStyle", 0, false);
    this.addColumnDefinition("MaterialCodeName", "erpStyle", 0, false);
    this.addColumnDefinition("PrePrductionDate", "preProductionDate", 0, false);
    this.addColumnDefinition("PlanStartDate", "planStartDate", 0, false);
    this.addColumnDefinition("PlanStopDate", "planStopDate", 0, false);
    this.addColumnDefinition("AcutualStartDate", "actualStartDate", 0, false);
    this.addColumnDefinition("AcutualStopDate", "actualStopDate", 0, false);
  }
  loadPreProductionList = (lookup_dialog, pageNumber, searchCriteria) => {
    let preProductionCriteria = new PreProductionSearchCriteria();
    preProductionCriteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      preProductionCriteria.preProductionNumberStartsWith =
        searchCriteria.preProductionNumberStartsWith;
      preProductionCriteria.preProductionNumberContains =
        searchCriteria.preProductionNumberContains;
      preProductionCriteria.vendorCode = searchCriteria.vendorCode;
      preProductionCriteria.status = searchCriteria.status;
      preProductionCriteria.sampleFabricStyle =
        searchCriteria.sampleFabricStyle;
      preProductionCriteria.preProductionDateTo =
        searchCriteria.preProductionDateTo;
      preProductionCriteria.preProductionDateFrom =
        searchCriteria.preProductionDateFrom;
      preProductionCriteria.planStartDateFrom =
        searchCriteria.planStartDateFrom;
      preProductionCriteria.planStopDateTo = searchCriteria.planStopDateTo;
      preProductionCriteria.planStopDateFrom = searchCriteria.planStopDateFrom;
      preProductionCriteria.planStopDateTo = searchCriteria.planStopDateTo;
      preProductionCriteria.actualStartDateFrom =
        searchCriteria.actualStartDateFrom;
      preProductionCriteria.actualStartDateTo =
        searchCriteria.actualStartDateTo;
      preProductionCriteria.actualStopDateFrom =
        searchCriteria.actualStopDateFrom;
      preProductionCriteria.actualStopDateTo = searchCriteria.actualStopDateTo;
      preProductionCriteria.actualStopDateTo = searchCriteria.actualStopDateTo;
      preProductionCriteria.designerStyle = searchCriteria.designerStyle;
      preProductionCriteria.erpStyle = searchCriteria.erpStyle;
    }
    let prePrductionpageList = new PageListBean();
    prePrductionpageList.pageSize = 50;
    prePrductionpageList.pageNumber = pageNumber;
    prePrductionpageList.currentPage = pageNumber;
    let preProductionrequestInput = new RestPreProductionListRequest();
    preProductionrequestInput.companyCode = this.companyCode;
    preProductionrequestInput.pageInput = prePrductionpageList;
    preProductionrequestInput.searchCriteria = preProductionCriteria;
    PreProductionService.getPreProductionPageList(
      preProductionrequestInput,
      (response) => this.loadPreProductionListResponse(response, lookup_dialog),
      this.loadPreProductionListError
    );
  };
  loadPreProductionListResponse = (response, lookup_dialog) => {
    let preProductionList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.preProductionPageList != null &&
      response.data.preProductionPageList.preProductions !== null
    ) {
      preProductionList = response.data.preProductionPageList.preProductions;
      totalCount = response.data.preProductionPageList.totalCount;
      currentPageNumber = response.data.preProductionPageList.currentPage;
      pageSize = response.data.preProductionPageList.pageSize;
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = preProductionList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadPreProductionListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, value) {
    let search = searchCriteria;
    if (search != null && search != "unDefined") {
      if (isEmptyString(search.preProductionNumberContains)) {
        search.preProductionNumberContains = value;
        this.searchCriteria = new PreProductionSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadPreProductionList(lookup_dialog, pageNumber, search);
    }
  }
}
const PreProductionLookupCriteraHandler = (companyCode) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new PreProductionSearchCriteria(),

        showAutoCompleteVendorList: true,
        vendorPageListForAutoCompleteList: new Array(),

        fabricPageListForAutoCompleteList: true,
        fabricPageListForAutoCompleteList: new Array(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
      this.initLookupHandlers();
    }
    initLookupHandlers = () => {
      let vendorLookupHandler = new VendorLookupHandler(companyCode, "Vendor");
      this.setState({ vendorLookupHandler: vendorLookupHandler });

      let fabricLookupHandler = new FabricStyleLookupHandler(
        companyCode,
        "Fabric Style"
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    };

    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new PreProductionSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };

    vendorCodeOnChange = (e) => {
      let vendorCode = e.target.value;
      this.state.showAutoCompleteVendorList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteVendorList;
      if (isEmpty(vendorCode)) {
        this.state.showAutoCompleteVendorList = false;
        let showAutoCompleteList = this.state.showAutoCompleteVendorList;
        let criteria = this.state.searchCriteria;
        criteria.vendorCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: criteria,
          vendorPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "vendorCode" &&
        showAutoCompleteList === true &&
        vendorCode !== ""
      ) {
        this.readVendorBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readandsetVendorDetailResponse = (response) => {
      let criteria = this.state.searchCriteria;
      if (response.data != null && response.data.vendor != null) {
        let vendorData = response.data.vendor;
        if (!isEmpty(vendorData)) {
          criteria.vendorCode = vendorData.code;
          this.setState({
            searchCriteria: criteria,
          });
        }
      }
    };
    readandsetVendorDetail = (vendorCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = vendorCode;
      input.isLoadChildren = true;
      VendorService.readVendor(
        input,
        this.readandsetVendorDetailResponse,
        this.errorCallBack
      );
    };
    readVendorBySearchString(searchString) {
      let searchCriteria = new VendorSearchCriteria();
      searchCriteria.companyCode = companyCode;
      searchCriteria.vendorCodeStartsWith = searchString;
      searchCriteria.vendorNameContains = searchString;
      let pageList = new PageListBean();
      pageList.pageSize = 100;
      let input = new RestVendorListRequest();
      input.companyCode = companyCode;
      input.pageInput = pageList;
      input.code = searchString;
      input.searchCriteria = searchCriteria;
      VendorService.getVendorPageList(
        input,
        this.readByVendorCodeResponse,
        this.errorCallBack
      );
    }
    readByVendorCodeResponse = (response) => {
      if (
        response.data != null &&
        response.data.vendorPageList != null &&
        response.data.vendorPageList.vendors != null
      ) {
        let vendorCodeData = response.data.vendorPageList.vendors;
        let simpleAutoCompleteList = new Array();
        if (vendorCodeData.length > 0 && vendorCodeData != null) {
          vendorCodeData.map((vendorCode) => {
            let simpleItemBean = {
              code: vendorCode.code,
              description: vendorCode.description,
            };
            simpleAutoCompleteList.push(simpleItemBean);
          });
        }
        this.setState({
          vendorPageListForAutoCompleteList: simpleAutoCompleteList,
        });
      }
    };
    vendorCodeEnterKeyEventHandler = (e) => {
      let vendorCode = e.target.value;
      this.readandsetVendorDetail(vendorCode);
      this.setState({
        vendorPageListForAutoCompleteList: new Array(),
      });
    };
    displayAutoCompleteVendorList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteVendorList: showAutoCompleteList });
    };

    fabricCodeOnChange = (e) => {
      let sampleFabricStyle = e.target.value;
      this.state.showAutoCompleteFabricList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      if (isEmpty(sampleFabricStyle)) {
        this.state.showAutoCompleteFabricList = false;
        let showAutoCompleteList = this.state.showAutoCompleteFabricList;
        let criteria = this.state.searchCriteria;
        criteria.sampleFabricStyle = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteFabricList: showAutoCompleteList,
          searchCriteria: criteria,
          fabricPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "sampleFabricStyle" &&
        showAutoCompleteList === true &&
        sampleFabricStyle !== ""
      ) {
        this.readFabricBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readandsetFabricStyleDetailResponse = (response) => {
      let criteria = this.state.searchCriteria;

      if (response.data != null && response.data.fabricStyle != null) {
        let fabricStyle = response.data.fabricStyle;
        if (!isEmpty(fabricStyle)) {
          criteria.sampleFabricStyle = fabricStyle.code;
          this.setState({
            searchCriteria: criteria,
          });
        }
      }
    };
    readandsetFabricStyleDetail = (fabricStyleCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = fabricStyleCode;
      input.isLoadChildren = true;
      this.setState({ isFabricStyleDataLoding: true });
      FabricStyleService.readFabricStyle(
        input,
        this.readandsetFabricStyleDetailResponse,
        this.errorCallBack
      );
    };

    readFabricBySearchString(searchString) {
      let searchCriteria = new FabricStyleSearchCriteria();
      searchCriteria.companyCode = companyCode;
      searchCriteria.fabricStyleCodeStartsWith = searchString;
      searchCriteria.fabricStyleNameStartsWith = searchString;
      let pageList = new RestPageListBean();
      pageList.pageSize = 100;
      let input = new RestFabricStyleListBeanRequest();
      input.companyCode = companyCode;
      input.pageInput = pageList;
      input.code = searchString;
      input.searchCriteria = searchCriteria;
      FabricStyleService.getActiveFabricStylesForAutoComplete(
        input,
        this.readByFabricCodeResponse,
        this.errorCallBack
      );
    }
    readByFabricCodeResponse = (response) => {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    };
    fabricEnterKeyEventHandler = (e) => {
      this.readandsetFabricStyleDetail(e.target.value);
      this.setState({ fabricPageListForAutoCompleteList: new Array() });
    };
    displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
      this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
    };
    errorCallBack = (error) => {
      ShowError(error);
    };

    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>preProductionNumberStartsWith#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="salesOrderNumberStartsWith"
                  name="preProductionNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.preProductionNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>PreProductionNumberContains#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="preProductionNumberContains"
                  name="preProductionNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.preProductionNumberContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Vendor</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="vendorCode"
                  name="vendorCode"
                  onChange={this.vendorCodeOnChange}
                  value={searchCriteria.vendorCode}
                  lookupRequired={true}
                  lookupHandler={this.state.vendorLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.vendorPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteVendorList}
                  showAutoCompleteList={this.state.showAutoCompleteVendorList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>FabricStyle</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="sampleFabricStyle"
                  name="sampleFabricStyle"
                  value={searchCriteria.sampleFabricStyle}
                  onChange={this.fabricCodeOnChange}
                  lookupRequired={true}
                  lookupHandler={this.state.fabricLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.fabricEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.fabricPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteFabricList}
                  showAutoCompleteList={this.state.showAutoCompleteFabricList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>PreProduction Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="preProductionDateFrom"
                  name="preProductionDateFrom"
                  onChange={this.onChange}
                  value={searchCriteria.preProductionDateFrom}
                />
              </Col>
              <Col sm={1}>
                <FormLabel>To</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="preProductionDateTo"
                  name="preProductionDateTo"
                  onChange={this.onChange}
                  value={searchCriteria.preProductionDateTo}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Plan Start Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="planStartDateFrom"
                  name="planStartDateFrom"
                  onChange={this.onChange}
                  value={searchCriteria.planStartDateFrom}
                />
              </Col>
              <Col sm={1}>
                <FormLabel>To</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="planStopDateTo"
                  name="planStopDateTo"
                  onChange={this.onChange}
                  value={searchCriteria.planStopDateTo}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Plan Stope Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="planStopDateFrom"
                  name="planStopDateFrom"
                  onChange={this.onChange}
                  value={searchCriteria.planStopDateFrom}
                />
              </Col>
              <Col sm={1}>
                <FormLabel>To</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="planStopDateTo"
                  name="planStopDateTo"
                  onChange={this.onChange}
                  value={searchCriteria.planStopDateTo}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="status"
                  value={searchCriteria.status}
                >
                  <option value={""}></option>
                  <option value={"A"}>Approve</option>
                  <option value={"U"}>UnApprove</option>
                  <option value={"M"}>Picked</option>
                  <option value={"L"}>Partially Picked</option>
                  <option value={"F"}>Invoiced / Finished</option>
                  <option value={"G"}>Partially Invoiced</option>
                  <option value={"X"}>Cancelled</option>
                </FormControl>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormLabel>Actual Start Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="actualStartDateFrom"
                  name="actualStartDateFrom"
                  onChange={this.onChange}
                  value={searchCriteria.actualStartDateFrom}
                />
              </Col>
              <Col sm={1}>
                <FormLabel>To</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="actualStartDateTo"
                  name="actualStartDateTo"
                  onChange={this.onChange}
                  value={searchCriteria.actualStartDateTo}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <FormLabel>Actual Stop Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="actualStopDateFrom"
                  name="actualStopDateFrom"
                  onChange={this.onChange}
                  value={searchCriteria.actualStopDateFrom}
                />
              </Col>
              <Col sm={1}>
                <FormLabel>To</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="actualStopDateTo"
                  name="actualStopDateTo"
                  onChange={this.onChange}
                  value={searchCriteria.actualStopDateTo}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={5}>
                <FormLabel>Dev</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="designerStyle"
                  name="designerStyle"
                  onChange={this.onChange}
                  value={searchCriteria.designerStyle}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>MaterialCodeName</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="erpStyle"
                  name="erpStyle"
                  onChange={this.onChange}
                  value={searchCriteria.erpStyle}
                />
              </Col>
            </Row>
            <Row className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
